// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"7\" viewBox=\"0 0 9 7\"> <path id=\"Polygon_1\" data-name=\"Polygon 1\" d=\"M4.5,0,9,7H0Z\" transform=\"translate(9 7) rotate(180)\" fill=\"#eb3a16\"/> </svg> ";
// Exports
module.exports = code;